export default "__VITE_ASSET__PVevPGLM__"